import { trpcAdmin, RouterOutputs } from '../lib/trpcAdmin';
import { proxy, useSnapshot } from 'valtio';

export const editorSettingsState = proxy({
  resource: {
    question: {} as Record<string, RouterOutputs['questions']['byId']>,
    activeBlock: {} as Record<'question', string> | Record<string, undefined>,
  },
});

export const handleSetActiveBlock = ({ type, id }: { type: 'question'; id: string }) => {
  editorSettingsState.resource.activeBlock[type] = id;
};

export const resetActiveBlock = () => {
  editorSettingsState.resource.activeBlock = {};
};

export const usePublishEditorSetting = () => {
  const {
    resource: { question },
  } = useSnapshot(editorSettingsState);

  // update questions
  const updateQuestionSettings = trpcAdmin.questions.update.useMutation();
  const questionValues = Object.values(question);

  return {
    mutateAsync: async () => {
      // TODO: why are we sequentially updating questions?
      // either we make a new mutation to update all questions at once
      // or we update all questions in parallel
      for (let i = 0; i < questionValues?.length; i++) {
        const questionValue = questionValues[i];

        if (questionValue?.id) {
          await updateQuestionSettings.mutateAsync({
            correct_answer_feedback: questionValue.correct_answer_feedback || undefined,
            id: questionValue.id,
            answer_feedback: questionValue.answer_feedback || false,
            assessment_required: questionValue.assessment_required || false,
            incorrect_answer_feedback: questionValue.incorrect_answer_feedback || undefined,
            horizontal_alignment: questionValue.horizontal_alignment || false,
            randomise_options: questionValue.randomise_options || false,
            required: questionValue.required || false,
          });
        }
      }
    },
  };
};
